import React from "react";
import { Device } from "../../../types/Device";
import { DirectionalCount } from "../../../types/Count";
import { BaseDeviceCard } from "./base-device-card";
import { CardContent } from "@mui/material";
import { DeviceCountTable } from "./count-table";

interface BidirectionalDeviceCardProps {
    device: Device;
    count: DirectionalCount;
    videoId?: string;
}

export const BidirectionalDeviceCard: React.FC<
    BidirectionalDeviceCardProps
> = ({ device, count, videoId }) => {
    const renderContent = () => {
        if (!count) return null;
        return (
            <CardContent
                sx={{
                    minHeight: 150,
                }}
            >
                <DeviceCountTable count={count} />
            </CardContent>
        );
    };
    return (
        <BaseDeviceCard
            device={device}
            count={count}
            videoId={videoId}
            renderContent={renderContent}
            getDeviceType={() => "bidirectional"}
        />
    );
};
